var m = require("mithril")

var datakosong = {
    master_product_id: '',
    price: 0,
    kode: '',
    name: '',
    unit: ''
}
var mDcProduct = {
    list: [],
    loadList: function(dcid) {
        return m.request({
            method: "POST",
            url: "/api/distributor/product/getall",
            withCredentials: true,
            body: {
                limit: 10,
                page: 0,
                dcid: dcid
            }
        })
        .then(function(result) {
            if(result.result)
            {
                mDcProduct.list = result.data
            }
            else{
                if(result.error[0].message == "You're not login")
                {
                    m.route.set('/login');
                }
            }
                
        })
    },
    current: datakosong,
    load: function(id, dcid, cb) {
        if(id == 'new')
        {
            mDcProduct.current = datakosong;
            cb();
        }
        else
        {
            return m.request({
                method: "POST",
                url: "/api/distributor/product/get", 
                withCredentials: true,
                body: {
                    id: id,
                    dcid: dcid
                }
            })
            .then(function(result) {
                if(result.result)
                {
                    mDcProduct.current = result.data;
                    //console.log(mDcOutlet.current);
                }
                else{
                    if(result.error[0].message == "You're not login")
                    {
                        m.route.set('/login');
                    }
                }
                cb();
            })
        }
        
    },

    save: function() {
        return m.request({
            method: "POST",
            url: "/api/distributor/product/insert",
            body: mDcProduct.current,
            withCredentials: true,
        })
        .then(function(result) {
            if(result.result)
            {
                //
            }
            else{
                if(result.error[0].message == "You're not login")
                {
                    m.route.set('/login');
                }
            }
        })
    }
}

module.exports = mDcProduct